<template>
  <div class>
    <header class="header flex-box">
      <div @click="back" class="flex1 flex-box flex-v-c">
        <i class="iconfont icon-houtui"></i> 返回
      </div>
      <div class="headerTitle flex1 flex-box flex-hv-c">商务{{managerId}}的详情</div>
      <div class="flex1"></div>
    </header>
    <div class="detailContent" v-cloak>
      <!-- 代理信息 -->
      <ul class="info">
        <li class="routerTodetail flex-box flex-v-c flex-h-e bb" @click="toDetail">
          <div class="flex-box flex-v-c flex-h-e toOther">
            查看他的代理
            <i class="iconfont icon-more"></i>
          </div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div class="flex1">
            <span>商务ID：</span>
            {{data.id}}
          </div>
          <div class="flex1">
            <span>真实姓名：</span>
            {{data.realname}}
          </div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div class="flex1 flex-box">
            <span>授权总数：</span>
            <div class="tip">{{data.totalMember}}</div>
          </div>
          <div class="flex1 flex-box">
            <span>绑定玩家数：</span>
            <div class="tip">{{data.totalBindPlayer}}</div>
          </div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div class="flex1 flex-box">
            <span>正式代理数：</span>
            <div class="tip">{{data.totalFormalMem}}</div>
          </div>
          <div class="flex1 flex-box">
            <span>预备代理数：</span>
            <div class="tip">{{data.totalPrepMem}}</div>
          </div>
        </li>

        <li class="flex-box flex-v-c bb">
          <span>创建时间：</span>
          <div v-if="data.createTime">{{data.createTime|formatDate('yyyy/MM/dd hh:mm:ss')}}</div>
        </li>
      </ul>
      <!-- 表格数据 -->
      <div class="table">
        <div class="flex-box flex-v-c picker bb">
          <div class="flex1 flex-box flex-hv-c startTime" @click="openPick('startTime')">
            {{startValue}}
            <span v-show="!startValue">开始时间</span>
          </div>
          <div
            class="flex1 flex-box flex-hv-c endTime"
            @click="openPick('endTime')"
            style="margin: 0 6px;"
          >
            {{endValue}}
            <span v-show="!endValue">结束时间</span>
          </div>
          <div class="flex1 flex-box flex-hv-c" @click="search">
            <div class="button searchBtn">
              搜索
              <i class="iconfont icon-search"></i>
            </div>
          </div>
        </div>

        <ul class="list">
          <li class="title flex-box bb bt">
            <div class="flex1 flex-box flex-hv-c br">时间</div>
            <div class="flex1 flex-box flex-hv-c br">正式代理</div>
            <div class="flex1 flex-box flex-hv-c br">预备代理</div>
            <div class="flex1 flex-box flex-hv-c br">开房数</div>
            <div class="flex1 flex-box flex-hv-c br">充值业绩</div>
            <div class="flex1 flex-box flex-hv-c">绑定玩家</div>
          </li>
          <li class="flex-box item bb" v-for=" (item,index) in data.list">
            <div class="flex1 flex-box flex-hv-c br">{{item.name}}</div>
            <div class="flex1 flex-box flex-hv-c br">{{item.formalMember}}</div>
            <div class="flex1 flex-box flex-hv-c br">{{item.prepMember}}</div>
            <div class="flex1 flex-box flex-hv-c br">{{item.createRoom}}</div>
            <div class="flex1 flex-box flex-hv-c br">{{item.recharge}}</div>
            <div class="flex1 flex-box flex-hv-c">{{item.bindPlayer}}</div>
          </li>
          <li class="flex-box item bb">
            <div class="flex1 flex-box flex-d-c flex-hv-c br">
              <div>{{startValue?startValue:'年/月/日'}}</div>
              <div>至</div>
              <div>{{endValue?endValue:'年/月/日'}}</div>
            </div>
            <div class="flex1 flex-box flex-hv-c br">{{searchData.formalMember}}</div>
            <div class="flex1 flex-box flex-hv-c br">{{searchData.prepMember}}</div>
            <div class="flex1 flex-box flex-hv-c br">{{searchData.createRoom}}</div>
            <div class="flex1 flex-box flex-hv-c br">{{searchData.recharge}}</div>
            <div class="flex1 flex-box flex-hv-c">{{searchData.bindPlayer}}</div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 时间选择 -->
    <mt-datetime-picker
      ref="startTime"
      v-model="pickerValue"
      type="date"
      year-format="{value} 年"
      month-format="{value} 月"
      date-format="{value} 日"
      :startDate="startDate"
      @confirm="handleConfirm('start')"
    ></mt-datetime-picker>
    <mt-datetime-picker
      ref="endTime"
      v-model="pickerValue"
      type="date"
      year-format="{value} 年"
      month-format="{value} 月"
      date-format="{value} 日"
      :startDate="startDate"
      @confirm="handleConfirm('end')"
    ></mt-datetime-picker>
  </div>
</template>
<!--javascript-->
<script>
export default {
  props: ['managerId'],
  data: function () {
    return {
      data: {},
      searchData: {},
      startValue: '',
      endValue: '',//默认显示
      pickerValue: new Date(),
      startDate: new Date('2016/01/1'),
      begin: '',
      end: '',
    }
  },
  methods: {
    getData() {

      this.$http.get('/subManager/managerInfo', { params: { managerId: this.managerId } }).then((res) => {
        if (res.code == 0) {
          this.data = res.data
        } else {
          this.$toast(res.message)
        }
      })
    },
    getSearchData() {
      if (new Date(this.endValue).getTime() < new Date(this.startValue).getTime()) {
        this.$toast('结束时间不能小于开始时间');
        return
      }

      this.$http.get('/subManager/managerSearch', { params: { managerId: this.managerId, begin: this.begin, end: this.end } }).then((res) => {
        if (res.code == 0) {
          this.searchData = res.data
        } else {
          this.$toast(res.message)
        }
      })
    },
    /******
    * 打开时间选择
    * ***/
    openPick(param) {
      var that = this
      that.$refs[param].open()
    },
    /******
     * 确认时间
     * ***/
    handleConfirm(param) {
      let d = new Date(this.pickerValue)
      let time = d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate()
      console.log(time)
      if (param == 'start') {
        this.startValue = time
        this.begin = new Date(time).getTime()
      } else if (param == 'end') {
        this.endValue = time
        this.end = new Date(time).getTime() + (1 * 24 * 3600 * 1000)
      }
    },
    search() {
      this.getSearchData()
    },
    back() {
      this.$emit('ctrDetails', false)
    },
    // 跳转路由
    toDetail() {
      this.$router.push({ path: '/member', query: { managerId: this.managerId } });
    }
  },
  mounted: function () {
    this.getData()
  },
  created: function () {
  }

}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.detail {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background: #fff;
  width: 100%;
  height: 100%;
}
.table {
  margin: 0.5rem 0;
  border-top: 2px solid #3d435f;
}

.detailContent {
  -webkit-overflow-scrolling: touch;
  overflow: auto;
  height: calc(100vh - 1rem);
  padding: 10px;
}
ul li {
  min-height: 0.7rem;
}
ul.info span {
  color: #999;
}
.tip {
  color: orangered !important;
}

ul.list {
  margin-top: 0.2rem;
  li {
    min-height: 0.7rem;
    div {
      word-break: break-all;
      padding: 0 2px;
    }
  }
  li.title {
    background: #f8f8f8;
  }
}
.picker {
  height: 0.8rem;
}

.searchBtn {
  width: 100%;
  height: 0.6rem;
}

.startTime,
.endTime {
  height: 0.6rem;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.toOther {
  width: 2.4rem;
  height: 0.6rem;
  background: #469859;
  color: #fff;
  border-radius: 4px;
  margin: 0 0 10px 0;
}
.icon-more:before {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/managerFind/detail.vue